import type {
  CurrentStepsResponseDto,
  OnboardingStepDto,
  StartOnboardingResponseDto,
} from '../contracts/onboardingContracts'
import type {
  CurrentStepsResult,
  OnboardingStep,
  StartOnboardingResult,
} from '../../types/onboardingTypes'

// A missing label renders as "-" (house rule); a missing order sorts last
// rather than poisoning the sort with NaN.
const toOnboardingStep = (dto: OnboardingStepDto): OnboardingStep => ({
  flowStepId: dto.flowStepId ?? '',
  stepOrder: Number.isFinite(dto.stepOrder) ? dto.stepOrder : Number.MAX_SAFE_INTEGER,
  stepKey: dto.stepKey ?? '',
  stepLabel: dto.stepLabel || '-',
  description: dto.description ?? '',
  isMandatory: dto.isMandatory ?? false,
  isSkippable: dto.isSkippable ?? false,
  status: dto.status ?? 'pending',
  // `?? false` keeps the FE safe with older payloads that pre-date the
  // backend adding this flag — falls back to non-markable, which means
  // "route to a dedicated flow if one exists; else hide the CTA".
  isUserMarkable: dto.isUserMarkable ?? false,
})

export const parseStartOnboardingResponse = (
  resp: StartOnboardingResponseDto,
): StartOnboardingResult => {
  const data = resp.data ?? {}
  return {
    flowId: data.flowId ?? '',
    assignmentId: data.assignmentId ?? '',
    investorId: data.investorId ?? '',
    onboardingStatus: data.onboardingStatus ?? '',
    steps: (data.steps ?? []).map(toOnboardingStep),
  }
}

export const parseCurrentSteps = (resp: CurrentStepsResponseDto): CurrentStepsResult => {
  const data = resp.data ?? {}
  return {
    onboardingStatus: data.onboardingStatus ?? '',
    steps: (data.steps ?? []).map(toOnboardingStep),
  }
}
